.active{color:#38c321}.inactive{color:red}
/*# sourceMappingURL=admin-panel-cell-decorator.component-IKBG45GQ.css.map */
